export const namespaced = true
export const state = {
  userRegisterData: null
}
